import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from './useAuthStore'
import { subscribeToContactInfo } from '@/services/ContactInfoService'

export const useLeadStore = defineStore('lead', () => {
  const lead = ref({})
  let unsubscribeFromContactInfo = null
  let stopWatchingUid = null

  const authStore = useAuthStore()
  const { uid } = storeToRefs(authStore)

  function initialize() {
    // React to uid changes and (re)subscribe
    stopWatchingUid = watch(uid, (newUid) => {
      if (unsubscribeFromContactInfo) {
        unsubscribeFromContactInfo()
        unsubscribeFromContactInfo = null
      }
      if (!newUid) {
        lead.value = { status: null }
        return
      }
      unsubscribeFromContactInfo = subscribeToContactInfo(newUid, (value) => {
				lead.value = value || { status: null }
      })
    }, { immediate: true })
  }

  function dispose() {
    if (unsubscribeFromContactInfo) {
      unsubscribeFromContactInfo()
      unsubscribeFromContactInfo = null
    }
    if (stopWatchingUid) {
      stopWatchingUid()
      stopWatchingUid = null
    }
  }

  return {
    lead,
    initialize,
    dispose,
    uid,
  }
})